<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10" class="d-flex">
                                        <h4 id="traffic" class="card-title mb-0">
                                            {{this.getLanguage["GS"][obj_gps.I > 0? "EP888S": "AP888S"]}}
                                        </h4>
                                        <!--<div class="custom_tooltip"
                                             v-on:click="copyIP()"
                                             >
                                            <i class="fa fa-question-circle"></i>
                                            <span class="tooltiptext" style="background-color: black;color: white;text-align: left;">
                                                <span style="white-space: pre-line;">{{this.getLanguage["GPS"]["PVIS"]}}</span><br />
                                                <span style="white-space: pre-line;">{{this.getLanguage["GPS"]["PVIP"]}}</span>
                                            </span>
                                        </div>-->
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["GPS"]["BN"]}}<span class="required" /> :</label>
                                        <customtreeselect :multiple="false"
                                                    :options="dd_agentgroup"
                                                    :flat="true"
                                                    :defaultExpandLevel="Infinity"
                                                    :clearable="false"
                                                    :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                    v-model="obj_gps['AGIT']"
                                                    @input="AgentGroupChange"
                                                    :disabled="obj_gps.I > 0"
                                                    ref="AGIT"
                                                    @select="AgentGroupChangeForCurrencyFilter" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                    </CCol>

                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["DM"]["C"]}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_currency"
                                                    :defaultExpandLevel="1"
                                                    valueConsistsOf="LEAF_PRIORITY"
                                                    :placeholder="getLanguage['DM']['C']"
                                                    v-model="obj_gps.CI"
                                                    @input="CurrencyChange"
                                                    ref="PCI" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('CI', 'C') }}</span>
                                    </CCol>
                                </CRow>

                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["GPS"]["P888AI"]}} :</label>
                                        <CInput type="text" size="sm" vertical :placeholder="this.getLanguage['GPS']['SV1']" :value="obj_gps.OC" @change="v => obj_gps.OC = v"></CInput>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["GPS"]["P888S"]}} :</label>
                                        <CInput type="text" size="sm" vertical :placeholder="this.getLanguage['GPS']['SV2']" :value="obj_gps.SK" @change="v => obj_gps.SK = v"></CInput>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["GPS"]["P888C"]}} :</label>
                                        <CInput type="text" size="sm" vertical :placeholder="this.getLanguage['GPS']['SV3']" :value="obj_gps.AC" @change="v => obj_gps.AC = v"></CInput>
                                    </CCol>
                                </CRow>
                                <!--<div class='subHeaderHR' style="margin-top:5px;"></div>
                                <div style="color:red;">
                                    <span style="white-space: pre-line;">{{this.getLanguage["GPS"]["PVIS"]}}</span><br />
                                    <span style="white-space: pre-line;">{{this.getLanguage["GPS"]["PVIP"]}}</span>
                                </div>-->
                                <!--<cRow>
                                    <div style="color:red;">
                                        <span style="white-space: pre-line;">{{this.getLanguage["GPS"]["PVIS"]}}</span><br />
                                        <span style="white-space: pre-line;">{{this.getLanguage["GPS"]["PVIP"]}}</span>
                                    </div>
                                </cRow>-->

                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveGPS()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["P888S"]}}</h2>
                        <CButton v-if="checkModuleAccess2(constAccessType.add)" size="sm" color="outline-info" @click="addGPS()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["HFS"]["BN"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroupfs"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[1].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[1].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[1].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[1].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[1].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[1].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage["P888S"]["P888SL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <!--Brand-->
                                <th>{{this.getLanguage["HFS"]["BN"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["DM"]["C"]}}<i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i></th>
                                <!--Pussy888 AgentCode -->
                                <th>{{this.getLanguage["GPS"]["P888AI"]}}</th>
                                <!--Pussy888 Secret-->
                                <th>{{this.getLanguage["GPS"]["P888S"]}}</th>
                                <!--Pussy888 AuthCode-->
                                <th>{{this.getLanguage["GPS"]["P888C"]}}</th>
                                <th>{{this.getLanguage["GL"]["CB"]}}</th>
                                <th>{{this.getLanguage["GL"]["CT"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UB"]}}</th>
                                <th>{{this.getLanguage["GL"]["UTS"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <!--Brand-->
                                <th>{{this.getLanguage["HFS"]["BN"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["DM"]["C"]}}<i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i></th>
                                <!--Pussy888 AgentCode -->
                                <th>{{this.getLanguage["GPS"]["P888AI"]}}</th>
                                <!--Pussy888 Secret-->
                                <th>{{this.getLanguage["GPS"]["P888S"]}}</th>
                                <!--Pussy888 AuthCode-->
                                <th>{{this.getLanguage["GPS"]["P888C"]}}</th>
                                <th>{{this.getLanguage["GL"]["CB"]}}</th>
                                <th>{{this.getLanguage["GL"]["CT"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UB"]}}</th>
                                <th>{{this.getLanguage["GL"]["UTS"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_gpsl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_gpsl">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-trash" @click="removeGPS(data)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)">
                                        <i class="cil-trash"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-color-border" @click="editGPS(data.I)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)">
                                        <i class="cil-color-border"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>{{ data.GN }} ({{data.PC}})</td>
                            <td>{{ data.PCI }}</td>
                            <td>{{ data.SV1 }}</td>
                            <td>{{ data.SV2 }}</td>
                            <td>{{ data.SV3 }}</td>
                            <td>{{ data.CB }}</td>
                            <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.UB }}</td>
                            <td>{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import { required } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI" }, { F: "CTS", FV: { startDate: "", endDate: "" } }, { F: "GPI", FV: "105" }], //Filter Value
                dd_do: [], // Domain Option
                dd_dofs: [], // Domain Option for search
                arry_gpsl: [], //header footer script list
                obj_gps: {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    SV1: null,
                    SV2: null,
                    SV3: null,
                    AGI: "",
                    AGIT: null,
                    OC: null,
                    SK: null,
                    PCI: null,
                    CI: null,
                    MU: "",
                    DU: "",
                    GPI: "",
                    GN: "",
                    AC: null
                }, // add header footer script
                dd_agentgroup: [],//agent group option
                dd_agentgroupfs: [],//agent group option
                dd_currencydefault: [{ "id": "MYR", "label": "MYR", "ICT": false }, { "id": "THB", "label": "THB", "ICT": false }, { "id": "IDR", "label": "IDR", "ICT": false }, { "id": "USD", "label": "USD", "ICT": false }],
                dd_currencyagent: [],
                dd_currency: [],
                constAccessType: constAccessType,
            }
        },
        validations: {
            obj_gps: {
                AGIT: { required },
                CI: { required },
            }
        },
        created() {
            this.$parent.showSubMenu = 'GS';
            this.$parent.showActiveMenu = 'GS.P888S';
            this.getGPSList();
            this.getAgentGroup();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;

        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        methods: {
            copyIP() {
                var inp = document.createElement('input');
                document.body.appendChild(inp)
                inp.value = "18.138.13.157;13.251.218.79";
                inp.select();
                document.execCommand('copy', false);
                inp.remove();
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[1].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[1].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[1].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[1].FV.endDate = "";
                    }
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('GPS', 'GS', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getGPSList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getGPSList();
                }
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                                that.str_FV[0].FV = agi;
                            }
                        });
                }
                else {
                    this.str_FV[0].FV = null;
                }


            },
            AgentGroupChange(value) {
                var that = this;
                var agi = 0;

                if (value != "") {
                    agi = value.split("-")[1];
                }

                this.getDataApi(`/api/dd/dn/` + agi,
                    function (d, s) {
                        if (s) {
                            that.dd_do = d.dropdownlist
                        }
                    });

                this.getDataApi(`/api/dd/cur/` + agi,
                    function (d, s) {
                        if (s) {
                            that.dd_currencyagent = d.dropdownlist
                            that.dd_currency = [];
                            that.dd_currency = that.dd_currencyagent.filter(element => that.dd_currencydefault.some(element1 => element1.label == element.label));

                            if (that.dd_currency.length == 1) {
                                that.obj_gps.CI = that.dd_currency[0].id;
                            }
                        }
                    });
            },
            AgentGroupChangeForCurrencyFilter(value) {
                var that = this;
                var agi = 0;

                if (value.id != "") {
                    agi = value.id.split("-")[1];
                }

                this.getDataApi(`/api/dd/cur/` + agi,
                    function (d, s) {
                        if (s) {
                            that.dd_currencyagent = d.dropdownlist                            
                            that.dd_currency = [];
                            that.dd_currency = that.dd_currencyagent.filter(element => that.dd_currencydefault.some(element1 => element1.label == element.label));

                            if (that.dd_currency.length == 1) {
                                that.obj_gps.CI = that.dd_currency[0].id;
                            }
                        }
                    });
            },
            getGPSList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                var split = this.str_FV[i].FV[x].split("-");

                                if (split.length == 2) {
                                    temp_ += split[1];
                                }
                                else {
                                    temp_ += split[0];
                                }
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };
                this.getDataApi(`/api/gps/pussy888/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setGPSList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setGPSList(data) {
                //for (var i = 0; i < data.Items.length; i++) {
                //    data.Items[i].SV1 = JSON.parse(data.Items[i].SV1);
                //    data.Items[i].SV2 = JSON.parse(data.Items[i].SV2);

                //}

                this.arry_gpsl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            setGPS(data) {
                if (data) {
                    //data.SV1 = JSON.parse(data.SV1);
                    //data.SV2 = JSON.parse(data.SV2);
                    this.obj_gps.OC = data.SV1;
                    this.obj_gps.SK = data.SV2;
                    this.obj_gps.AC = data.SV3;
                }
                this.obj_gps = Object.assign(this.obj_gps, data);
                this.bool_isAMV = true;
            },
            addGPS() {
                this.obj_gps = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    SV1: null,
                    SV2: null,
                    SV3: null,
                    AGI: "",
                    AGIT: null,
                    OC: null,
                    SK: null,
                    PCI: null,
                    CI: null,
                    MU: "",
                    DU: "",
                    GPI: "",
                    GN: "",
                    AC:null
                };
                this.bool_CV = false;
                this.bool_isAMV = true;

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.obj_gps.AGIT = this.dd_agentgroup[0].id;
                        this.AgentGroupChange(this.obj_gps.AGIT);
                    }
                }
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_gps[value];
                    if (value == 'CI') {
                        if (validateObj.required != undefined && !validateObj.required) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["DM"][langKey]);
                        }
                    }
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["HFS"][langKey]);
                    }
                }

            },
            saveGPS() {
                this.bool_CV = true;
                this.obj_gps['RS'] = 2;

                if (this.obj_gps.AGIT != null && this.obj_gps.AGIT.length > 0) {
                    var agi = this.obj_gps.AGIT.split("-");
                    this.obj_gps.AGI = agi[1];
                }                
                this.obj_gps['GPI'] = "105"
                this.obj_gps['SV1'] = this.obj_gps.OC
                this.obj_gps['SV2'] = this.obj_gps.SK
                this.obj_gps['SV3'] = this.obj_gps.AC

                //this.obj_gps['SV1'] = JSON.stringify(this.obj_gps.SV1)
                //this.obj_gps['SV2'] = JSON.stringify(this.obj_gps.SV2)

                this.$v.obj_gps.$touch();
                if (!this.$v.obj_gps.$error) {
                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.postDataApi(`/api/gps/pussy888/s`, this.obj_gps,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getGPSList();
                            }
                        });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_gps"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            editGPS(id) {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/gps/pussy888/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setGPS(d.D);
                            that.bool_isAMV = false;
                            if (that.obj_gps.AGI != 0) {
                                that.obj_gps.AGIT = "3-" + that.obj_gps.AGI;
                                that.AgentGroupChange(that.obj_gps.AGIT);
                            }
                            that.bool_isAMV = true;
                        }
                    });
            },
            removeGPS(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: data.I,
                            uts: data.UTS,
                            di: data.DI
                        };

                        this.postDataApi(`/api/gps/pussy888/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getGPSList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getGPSList();
            },
            setFlag(languageCode) {
                return this.mapLanguageFlag(languageCode);
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[1].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            CurrencyChange(value) {
                var that = this;
                this.dd_currency.find(function (val, idx) {
                    if (val.id == value) {
                        that.obj_gps['PCI'] = val.label;
                    }
                });
            },
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getGPSList();
            },
        },

    }

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/GameSettings/Pussy888Setting.vue